import Honeybadger from '@honeybadger-io/js'

// Keys are injected via meta tags by the Rails layout (ERB), since webpack
// cannot process .erb files and would embed raw template strings as the key.
export const meta = (name) => document.querySelector(`meta[name="${name}"]`)?.content

const apikey = meta('honeybadger-api-key') || ''
const env = meta('honeybadger-environment') || 'development'
const host = meta('honeybadger-host') || 'api.honeybadger.io'
const uiHost = meta('honeybadger-ui-host') || 'app.honeybadger.io'

const contextMetaKeys = [
  'form-id',
  'form-version',
  'submission-id',
  'department-id',
  'company-id',
]

const context = contextMetaKeys.reduce((acc, key) => {
  const value = meta(key)
  if (value !== undefined) {
    acc[key.replace(/-/g, '_')] = value
  }
  return acc
}, {})

export const ReportHandler = Honeybadger.configure({
  apiKey: apikey,
  reportData: true,
  environment: env,
  host: host,
  uiHost: uiHost,
})

ReportHandler.setContext(context)

// exporting for legacy uses (builder)
export const ErrorReporter = (error, options = {}) => {
  const { message, name } = options
  ReportHandler.notify(error, {
    message: message || error?.message || 'Unknown error',
    name: name || error?.name || 'Unknown error',
  })
}

// exports cleaned notify and setContext for use in React components
export const useHoneyBadger = () => {
  return [
    ErrorReporter,
    (...args) => ReportHandler.setContext(...args)
  ]
}
